module.exports = __webpack_public_path__ + "img/icon_9.3de81f8c.png";